import { render, staticRenderFns } from "./Garde.vue?vue&type=template&id=90caaab4"
import script from "./Garde.vue?vue&type=script&lang=js"
export * from "./Garde.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports